export class AsyncFileRequestsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAsyncFileRequest({ id }) {
    return this.#http.get(`/AsyncFileRequests/${id}`);
  }
}
